import PopUpNews from './PopUpNews'

export default PopUpNews
